// extracted by mini-css-extract-plugin
export default {"work":"works_work__8RVP4","workSum":"works_workSum__sWe1b","workSumDanger":"works_workSumDanger__HHHy0","workSumUpdate":"works_workSumUpdate__Ii+iQ"};